import React from 'react';

import styled from '@emotion/styled';

import { Box } from '@clutter/clean';

import { TOKENS } from '@root/components/www/home/tokens';

import trustPilot from '@images/reviews/trust_pilot.svg';
import trustPilotOnDark from '@images/reviews/trust_pilot_on_dark.svg';
import yelp from '@images/reviews/yelp.svg';

const Grid = styled.div<{ $onDark?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ $onDark }) => ($onDark ? TOKENS.space[24] : '16px')};
  margin-top: ${({ $onDark }) => ($onDark ? 0 : '16px')};
`;

const TrustScore = styled.p<{ $onDark?: boolean }>`
  margin: 4px 0 0;
  font-family: ${TOKENS.font.sans};
  font-size: ${({ $onDark }) => ($onDark ? '12px' : '8px')};
  line-height: 1.3;
  color: ${({ $onDark }) => ($onDark ? TOKENS.color.onDarkMuted : 'inherit')};

  b {
    font-weight: 500;
    color: ${({ $onDark }) => ($onDark ? TOKENS.color.onDark : 'inherit')};
  }
`;

export const Ratings: React.FC<{ onDark?: boolean }> = ({ onDark }) => (
  <Grid $onDark={onDark}>
    <Box.Flex flexDirection="column" alignItems="center">
      <img
        src={onDark ? trustPilotOnDark : trustPilot}
        width={onDark ? 120 : 104}
        draggable={false}
        alt="Trustpilot"
        loading="lazy"
      />
      <TrustScore $onDark={onDark}>
        TrustScore: <b>4.8 | 2,500+</b> reviews
      </TrustScore>
    </Box.Flex>
    <Box textAlign="center">
      <img
        src={yelp}
        alt="Yelp"
        width={onDark ? 80 : 72}
        draggable={false}
        loading="lazy"
      />
    </Box>
  </Grid>
);
